export enum ReportType {
  CLOSURE = 'CLOSURE',
  INCOMPLETE = 'INCOMPLETE',
  UNRELATED_VIDEO = 'UNRELATED_VIDEO',
  QUALITY_VIDEO = 'QUALITY_VIDEO',
  INSTAGRAM = 'INSTAGRAM',
  SPAM = 'SPAM',
  BROKEN_LINK = 'BROKEN_LINK'
}
